/** React Router's URL path */
export const PATH = '/project_information'

/** title on the layout header */
export const HEADER = 'Project Information'



// WEBPACK FOOTER //
// ./src/pages/project-information/constants.js